
import axios from "axios";

import { IP } from "../utils/Host";

// zmiana procesora w grupie z poziomu technologia stage
export function dragDropProcesGrupaToProcesorGant(id_drag_grupa_proces,id,global_id_drag,global_id_drop,procesor_id_drag,procesor_id_drop,refreshGantAll) {

// id = procesor id
  
  axios
  .get(IP + "drag_drop_proces_grupa_to_procesor_gant/"+id_drag_grupa_proces+"/"+id+"/"+global_id_drag+"/"+global_id_drop+"/"+procesor_id_drag+"/"+procesor_id_drop)
    .then((res) => {
refreshGantAll()

    })
}
